<!-- Backdrop -->
<div class="fp-backdrop" *ngIf="open" (click)="close()"></div>

<!-- Panel -->
<aside class="fp-panel" [class.fp-panel--open]="open">

  <!-- Header -->
  <div class="fp-header">
    <span class="fp-title">Filters</span>
    <button type="button" class="fp-close" (click)="close()" title="Close">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <!-- Is Mandatory (server-side filter — re-queries on change) -->
  <div class="fp-mandatory" *ngIf="showMandatory">
    <label class="fp-mandatory-label">Is Mandatory</label>
    <select class="fp-operator-select"
            [value]="mandatoryValue"
            (change)="onMandatoryPick($any($event.target).value)">
      <option value="true">Mandatory</option>
      <option value="false">Non-Mandatory</option>
      <option value="">All</option>
    </select>
  </div>

  <!-- Field search -->
  <div class="fp-search-wrap">
    <i class="bi bi-search fp-search-icon"></i>
    <input type="text" class="fp-search-input" placeholder="Search fields..."
           [(ngModel)]="fieldSearch"
           (ngModelChange)="onFieldSearchChange()" />
  </div>

  <!-- Field list -->
  <div class="fp-field-list">
    <ng-container *ngFor="let group of groupedDefs; trackBy: trackByGroup">
      <div class="fp-group-label" *ngIf="group.group">{{ group.group }}</div>

      <div class="fp-field-item" *ngFor="let def of group.defs; trackBy: trackByKey">

        <!-- Checkbox row -->
        <div class="fp-field-row" (click)="toggleField(def)">
          <input type="checkbox" class="fp-checkbox"
                 [checked]="isActive(def.key)"
                 (click)="$event.preventDefault(); $event.stopPropagation(); toggleField(def)" />
          <span class="fp-field-label">{{ def.label }}</span>
        </div>

        <!-- Expanded controls -->
        <div class="fp-field-controls" *ngIf="isActive(def.key)">
          <ng-container *ngIf="getRuleFor(def.key) as rule">

            <!-- Operator -->
            <select class="fp-operator-select"
                    [value]="rule.operator"
                    (change)="setOperator(def.key, $any($event.target).value)">
              <option *ngFor="let op of operatorsFor(def.type); trackBy: trackByOperator"
                      [value]="op.value"
                      [selected]="op.value === rule.operator">
                {{ op.label }}
              </option>
            </select>

            <!-- TEXT -->
            <ng-container *ngIf="def.type === 'text' && needsValueInput(rule.operator)">
              <input type="text" class="fp-value-input" placeholder="Value..."
                     [value]="rule.value ?? ''"
                     (input)="setValue(def.key, $any($event.target).value)" />
            </ng-container>

            <!-- NUMBER -->
            <ng-container *ngIf="def.type === 'number' && needsValueInput(rule.operator)">
              <input type="number" class="fp-value-input" placeholder="Value..."
                     [value]="rule.value ?? ''"
                     (input)="setValue(def.key, +$any($event.target).value)" />
              <ng-container *ngIf="isBetween(rule.operator)">
                <span class="fp-between-sep">and</span>
                <input type="number" class="fp-value-input" placeholder="To..."
                       [value]="rule.value2 ?? ''"
                       (input)="setValue2(def.key, +$any($event.target).value)" />
              </ng-container>
            </ng-container>

            <!-- DATE -->
            <ng-container *ngIf="def.type === 'date' && needsValueInput(rule.operator) && !isDateShortcut(rule.operator)">
              <input type="date" class="fp-value-input"
                     [value]="rule.value ?? ''"
                     (change)="setValue(def.key, $any($event.target).value)" />
              <ng-container *ngIf="isBetween(rule.operator)">
                <span class="fp-between-sep">and</span>
                <input type="date" class="fp-value-input"
                       [value]="rule.value2 ?? ''"
                       (change)="setValue2(def.key, $any($event.target).value)" />
              </ng-container>
            </ng-container>

            <!-- ENUM -->
            <ng-container *ngIf="def.type === 'enum'">
              <div class="fp-enum-wrap">
                <input *ngIf="filteredOptions(def.key).length > 6"
                       type="text" class="fp-enum-search" placeholder="Search options..."
                       [(ngModel)]="enumSearchMap[def.key]" />
                <div class="fp-chips">
                  <button *ngFor="let opt of filteredOptions(def.key)"
                          type="button"
                          class="fp-chip"
                          [class.fp-chip--selected]="isEnumSelected(def.key, opt.value)"
                          (click)="toggleEnumValue(def.key, opt.value)">
                    {{ opt.label }}
                  </button>
                </div>
                <span *ngIf="filteredOptions(def.key).length === 0" class="fp-no-options">
                  No options available
                </span>
              </div>
            </ng-container>

          </ng-container>
        </div>
      </div>
    </ng-container>

    <div class="fp-empty" *ngIf="filteredDefs.length === 0">
      No fields match "{{ fieldSearch }}"
    </div>
  </div>

  <!-- Footer -->
  <div class="fp-footer">
    <span class="fp-match-count">
      <ng-container *ngIf="workingRules.length > 0; else showAll">
        <strong>{{ matchCount }}</strong> of {{ rows.length }} records match
      </ng-container>
      <ng-template #showAll>Showing all {{ rows.length }} records</ng-template>
    </span>
    <div class="fp-footer-actions">
      <button type="button" class="secondary-btn" (click)="clearAll()">Clear All</button>
      <button type="button" class="primary-button" (click)="apply()">Apply</button>
    </div>
  </div>
</aside>
